import React from 'react';

import PageHeader from '../PageHeader';
import { useLocation, useNavigate, useSearchParams } from 'react-router';
import PeriodSelect from '../../containers/RootModal/components/PeriodSelect';
import AppConfig from '../../config';

const PeriodFilterPage = () => {
	const navigate = useNavigate();

	const selectPeriod = (dateFrom, dateTo) => {
		sessionStorage.setItem('filter-period', [dateFrom, dateTo]);
		navigate(-1);
	};

	return (
		<div className='Devices'>
			<PageHeader header='Period' collapsed={true} />

			<PeriodSelect selectPeriod={selectPeriod} />
		</div>
	);
};

export default PeriodFilterPage;
